/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Rag_Cta_LedeInputs */

const en_svc_rag_cta_lede = /** @type {(inputs: Svc_Rag_Cta_LedeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`And the document that should answer it. That is enough to see whether a knowledge base would help.`)
};

const lv_svc_rag_cta_lede = /** @type {(inputs: Svc_Rag_Cta_LedeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Un dokumentu, kam uz to būtu jāatbild. Ar to pietiek, lai redzētu, vai zināšanu bāze palīdzētu.`)
};

/**
* | output |
* | --- |
* | "And the document that should answer it. That is enough to see whether a knowledge base would help." |
*
* @param {Svc_Rag_Cta_LedeInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const svc_rag_cta_lede = /** @type {((inputs?: Svc_Rag_Cta_LedeInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Rag_Cta_LedeInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_svc_rag_cta_lede(inputs)
	return en_svc_rag_cta_lede(inputs)
});